import { Component, Input, OnInit, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { ExtractFromLoadService } from '../extract-from-load.service';

@Component({
  selector: 'app-config-popup',
  templateUrl: './config-popup.component.html',
  styleUrls: ['./config-popup.component.scss']
})
export class ConfigPopupComponent implements OnInit {

  public myControl = new FormControl();
  public options: any = [];
  public checked: false;
  fromTable: any;
  public filteredOptions: Observable<string[]>;
  public allComplete: false;
  public removedOptions: any = [];
  public addOptionsList: any = [];
  public selectedOptions: any = [];
  public cashmang: any;
  public checkedCategoryList: any;
  public gender: any;
  public auto: any;
  public headername: any;
  public selectedConfigData: any;
  searchValueA: string = '';
  searchValueB: string = '';
  sObject: any = [];
  rObject: any = [];
  constructor(
    private http: HttpClient,
    public dialogRef: MatDialogRef<ConfigPopupComponent>,
    private celService: ExtractFromLoadService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.headername = data.configData.APPLICATION;
    this.selectedConfigData = Object.assign({}, data.configData);
  }

  ngOnInit(): void {
    this.fromTable = this.celService.fromTable;
    if (this.fromTable) {
      this.headername = this.data.configData.application;
      this.options = JSON.parse(JSON.stringify(this.selectedConfigData.linedetail));
      if (this.options != null) {
        this.prepareOptionsListEdit(this.options);
      }
    } else {
      this.options = JSON.parse(JSON.stringify(this.selectedConfigData.TASK));
      if (this.options != null) {
        this.prepareOptionsList(this.options);
      }
    }
  }

  removeOptions(event, index, option) {
    const taskObj = option;
    taskObj.selectStatus = 'n';
    taskObj.checked = false;
    taskObj.paramVal = null;
    const list = Array.prototype.concat.call(this.removedOptions, taskObj);
    list.sort((a, b) => a.id - b.id);
    this.removedOptions = list;
    this.selectedOptions.splice(index, 1);
  }

  checkedOptionstoAdd(event, index, option) {
    const taskObj = option;
    taskObj.selectStatus = 'y';
    this.selectedOptions.splice(0, 0, taskObj);
    this.removedOptions.splice(index, 1);
  }

  removeOptionsEdit(event, index, option) {
    const taskObj = option;
    taskObj.taskselected = 'N';
    taskObj.checked = false;
    taskObj.paramVal = null;
    const list = Array.prototype.concat.call(this.removedOptions, taskObj);
    list.sort((a, b) => a.id - b.id);
    this.removedOptions = list;
    this.selectedOptions.splice(index, 1);
  }

  checkedOptionstoAddEdit(event, index, option) {
    const taskObj = option;
    taskObj.taskselected = 'Y';
    this.selectedOptions.splice(0, 0, taskObj);
    this.removedOptions.splice(index, 1);
  }

  deselectAllEdit() {
    const taskList = this.selectedOptions;
    taskList.forEach((element, index) => {
      element.taskselected = 'N';
      this.removedOptions.splice(index, 0, element);
    });
    this.selectedOptions.length = 0;
    this.searchValueA = '';
    this.searchValueB = '';
    this.search(1, '');
    this.search(2, '');
  }

  deselectAll() {
    const taskList = this.selectedOptions;
    taskList.forEach((element, index) => {
      element.selectStatus = 'n';
      element.checked = false;
      element.paramVal = null;
      this.removedOptions.splice(index, 0, element);
    });
    this.selectedOptions.length = 0;
    this.searchValueA = '';
    this.searchValueB = '';
    this.search(1, '');
    this.search(2, '');
  }


  selectAll() {
    const taskList = this.removedOptions;
    taskList.forEach((element, index) => {
      element.selectStatus = 'y';
      this.selectedOptions.splice(index, 0, element);
    });
    this.removedOptions.length = 0;
    this.searchValueA = '';
    this.searchValueB = '';
    this.search(1, '');
    this.search(2, '');
  }

  selectAllEdit() {
    const taskList = this.removedOptions;
    taskList.forEach((element, index) => {
      element.taskselected = 'Y';
      this.selectedOptions.splice(index, 0, element);
    });
    this.removedOptions.length = 0;
    this.searchValueA = '';
    this.searchValueB = '';
    this.search(1, '');
    this.search(2, '');
  }

  saveOptions() {
    this.searchValueA = '';
    this.searchValueB = '';
    this.search(1, '');
    this.search(2, '');
    if (this.selectedOptions.length === 0) {
      this.selectedConfigData.saveStatus = false;
    } else {
      this.selectedConfigData.saveStatus = true;
    }
    if (this.fromTable) {
      const data = {
        savedData: true,
        selectedConfigData: this.selectedConfigData
      };
      const taskList = [...this.selectedOptions, ...this.removedOptions];
      this.selectedConfigData.linedetail = taskList;
      this.dialogRef.close(data);
    } else {
      const data = {
        savedData: true,
        selectedConfigData: this.selectedConfigData
      };
      const taskList = [...this.selectedOptions, ...this.removedOptions];
      this.selectedConfigData.TASK = taskList;
      this.dialogRef.close(data);
    }
  }


  onCancel() {
    this.dialogRef.close("");
  }

  prepareOptionsList(options) {
    const tasks = options;
    tasks.forEach((element) => {
      if (element.selectStatus === "n") {
        this.removedOptions.push(element);
      } else {
        this.selectedOptions.push(element);
      }
    });
  }

  prepareOptionsListEdit(options) {
    const tasks = options;
    tasks.forEach((element) => {
      if (element.taskselected === "N") {
        this.removedOptions.push(element);
      } else {
        this.selectedOptions.push(element);
      }
    });
  }

  search(option, value) {
    const searchWord = value.trim().toUpperCase();
    if (option === 1) {
      this.selectedOptions = [...this.selectedOptions, ...this.sObject];
      this.sObject = [];
    }
    if (option === 2) {
      this.removedOptions = [...this.removedOptions, ...this.rObject];
      this.rObject = [];
    }

    if (this.fromTable) {
      if (option === 1) {
        const filterdValues = this.selectedOptions.filter((val) => val.taskname.toUpperCase().includes(searchWord));
        const otherValues = this.selectedOptions.filter((val) => !val.taskname.toUpperCase().includes(searchWord));
        this.selectedOptions = filterdValues;
        this.sObject = otherValues;
      }
      if (option === 2) {
        const filterdValues = this.removedOptions.filter((val) => val.taskname.toUpperCase().includes(searchWord));
        const otherValues = this.removedOptions.filter((val) => !val.taskname.toUpperCase().includes(searchWord));
        this.removedOptions = filterdValues;
        this.rObject = otherValues;
      }
    } else {
      if (option === 1) {

        const filterdValues = this.selectedOptions.filter((val) => val.TASK_NAME.toUpperCase().includes(searchWord));
        const otherValues = this.selectedOptions.filter((val) => !val.TASK_NAME.toUpperCase().includes(searchWord));
        this.selectedOptions = filterdValues;
        this.sObject = otherValues;
      }
      if (option === 2) {

        const filterdValues = this.removedOptions.filter((val) => val.TASK_NAME.toUpperCase().includes(searchWord));
        const otherValues = this.removedOptions.filter((val) => !val.TASK_NAME.toUpperCase().includes(searchWord));
        this.removedOptions = filterdValues;
        this.rObject = otherValues;
      }
    }
  }

  searchOnInput(event, i) {
    if (event == null || event == undefined || event == '') {
      this.search(i, '');
    } else if (event.length >= 3) {
      this.search(i, event);
    }
  }
}
